<template>
  <el-dialog
    :center="center"
    :close-on-click-modal="closeOnClickModal"
    :width="dialogWidth"
    :visible="dialogVisible"
    top="8vh"
    @close="closeDialog"
  >
    <template #title>
      <span class="el-dialog__title">{{ !dataIn.isAdd ? "编辑课程" : "添加VIP课程" }}</span>
    </template>
    <div class="backgroud-white cs-course-editor" v-loading="loading">
      <div class="backgroud-gray-popup popup-content-area-small">
        <el-form ref="form" :rules="rules" :model="model" label-width="100px">
          <div v-if="!dataIn.isAdd">
            <el-form-item label="真留项目" class="cs-form-label-row">
              <span>{{ dataIn.serviceItemName }}</span>
            </el-form-item>
            <el-form-item label="课程学期" class="cs-form-label-row">
              <span>{{ dataIn.termName }}</span>
            </el-form-item>
            <el-form-item label="原课程" class="cs-form-label-row">
              <span>{{ dataIn.courseName }}{{dataIn.isVIP ? "(VIP)": ""}}</span>
            </el-form-item>
          </div>
          <el-form-item v-if="dataIn.isAdd" label="学期">
            <el-select
              size="mini"
              v-model="model.termId"
              @change="onTermChange"
              placeholder="请选择学期"
            >
              <el-option
                v-for="term in termList"
                :key="term.Id"
                :label="term.DisplayLable"
                :value="term.Id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="新课程" prop="courseId">
            <el-select
              v-loading="isLoadingCourse"
              filterable
              v-model="model.courseId"
              placeholder="请选择课程"
              size="mini"
            >
              <el-option
                v-for="item in courseList"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="dataIn.isVIP" label="小时数">
            <el-input-number
              v-model="model.hours"
              :precision="0"
              :step="1"
              :max="dataIn.maxHours"
              :min="0"
              size="mini"
            ></el-input-number
            ><span>小时</span>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer popup-footer">
        <el-row>
          <el-col :span="24" class="text-center">
            <span v-if="!showError"></span>
            <el-alert
              :closable="false"
              v-if="showError"
              v-bind:title="errorMessage"
              type="error"
              show-icon
            ></el-alert>
          </el-col>
          <el-col class="text-center" :span="24">
            <el-button :disabled="loading" type="primary" @click="onSave()"
              >保存更新</el-button
            >
          </el-col>
        </el-row>
      </div>
    </div>
  </el-dialog>
</template>

<style lang="scss" scoped>
.cs-course-editor {
  color: black;
  h6 {
    font-weight: bold;
  }
  /deep/ .el-form-item__label {
    color: black;
  }
  .el-form-item {
    margin-bottom: 10px;
  }
}
</style>

<script>
import { mixinDevice } from "@/core/mixin";
import {
  changeStudyAbroadCourses,
  saveStudyAbroadCourses,
} from "../../service/studyAbroad.service";
import {
  getCoursesWithTerm,
  getCurrentNextTerms,
} from "../../service/speedupCourse.service";

export default {
  mixins: [mixinDevice],
  props: {
    center: {
      type: Boolean,
      default: true,
    },
    closeOnClickModal: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "700px",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    dataIn: {
      isAdd: Boolean,
      isVIP: Boolean,
      hours: Number,
      maxHours: Number,
      serviceItemName: String,
      termId: Number,
      termName: String,
      courseId: Number,
      courseName: String,
      workflowServiceItemId: Number,
      workflowCourseId: Number,
      universityGroup: Number,
    },
  },
  data() {
    return {
      model: {
        termId: "",
        courseId: "",
        hours: 0,
      },
      courseList: [],
      termList: [],
      title: "",
      courseLabel: "",
      isLoadingCourse: false,
      dialogVisible: false,
      showError: false,
      loading: false,
      errorMessage: "",
      rules: {
        courseId: [
          {
            required: true,
            trigger: "blur",
            message: "请选择课程",
          },
        ],
      },
    };
  },
  components: {},
  created() {
    this.dialogVisible = this.visible;
    this.$nextTick(async () => {
      this.init();
    });
   
  },
  computed: {
    dialogWidth() {
      return !this.isMobile() ? this.width : "100%";
    }
  },
  methods: {
    async init() {
      if (!!this.dataIn) {
        this.loading = true;

        this.model.hours = this.dataIn.hours;
        if (this.dataIn.isAdd) {
          this.model.courseId = "";
          this.title = "添加VIP新课程";
          this.courseLabel = "新课程";
          let result = await getCurrentNextTerms(1, 0);
          if (!!result && result.success) {
            this.termList = result.data;
            this.model.termId = this.termList[0].Id;
          }
        } else {
          this.courseLabel = "课程";
          this.model.termId = this.dataIn.termId;
          if (this.dataIn.isVIP) {
            this.title = "编辑VIP课程";
            this.model.courseId = this.dataIn.courseId;
          } else {
            this.title = "编辑课程";
            this.model.courseId = "";
          }
        }
        this.showError = false;
        this.loadCourseList();
      }
    },
    loadCourseList() {
      this.isLoadingCourse = true;
      getCoursesWithTerm(
        this.model.termId,
        this.dataIn.universityGroup,
        false
      ).then((result) => {
        if (result && result.success) {
          if (!!this.dataIn.courseId && !this.dataIn.isVIP) {
            let index = result.data.findIndex(
              (i) => i.Id == this.dataIn.courseId
            );

            if (index >= 0) {
              let list = result.data;
              list.splice(index, 1);
              this.courseList = list;
            }
          } else {
            this.courseList = result.data;
          }
        }
        this.loading = false;
        this.isLoadingCourse = false;
      });
    },
    onTermChange() {
      this.loadCourseList();
    },
    onSave() {
      if (!this.checkAllInputs()) {
        return;
      }

      if (!this.dataIn.isVIP){
        if (!this.model.courseId  || this.model.courseId == 0 || this.model.courseId == this.dataIn.courseId){
          this.$message.warning("请选择一个新课程");
          return;
        }
      }

      if (!this.dataIn.isAdd) {
        this.loading = true;
        changeStudyAbroadCourses(
          this.dataIn.workflowCourseId,
          this.model.courseId,
          this.model.hours
        ).then((result) => {
          if (result && result.success) {
            this.showError = false;
            this.$message.success("换课保存成功");
            this.$emit("saveSuccess", {
              workflowServiceItemId: this.dataIn.workflowServiceItemId,
              courseServiceRecordList: result.data,
            });
          } else {
            this.errorMessage = result.message;
            this.showError = true;
          }
          this.loading = false;
        });
      } else {
        if (this.dataIn.isVIP && this.model.hours == 0) {
          this.$message.warning("VIP课程需要输入小时数");
          return;
        }
        this.loading = true;
        let courseIdList = [this.model.courseId];
        let courseHours = {};
        courseHours[this.model.courseId] = this.model.hours;
        saveStudyAbroadCourses(
          this.dataIn.workflowServiceItemId,
          courseIdList,
          courseHours
        ).then((result) => {
          if (result && result.success) {
            this.showError = false;
            this.$message.success("课程保存成功");
            this.$emit("saveSuccess", {
              workflowServiceItemId: this.dataIn.workflowServiceItemId,
              courseServiceRecordList: result.data,
            });
          } else {
            this.errorMessage = result.message;
            this.showError = true;
          }
          this.loading = false;
        });
      }
    },
    checkAllInputs() {
      let isValid = true;
      this.$refs.form.validate((valid) => {
        if (!valid) {
          isValid = false;
          return;
        }
      });
      return isValid;
    },
    closeDialog() {
      this.dialogVisible = false;
      this.$emit("close");
    },
  },
  watch: {
    visible: function (newValue) {
      this.dialogVisible = newValue;
      if (newValue) {
        this.init();
      }
    },
    dataIn: function () {}
  },
};
</script>



// WEBPACK FOOTER //
// src/components/studyAbroad/courseEditor.vue